module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-02.6bce5a90.png";